__turbopack_context__.v({
  "enterYourEmail": "text-field1-module-scss-module__RZDoKa__enterYourEmail",
  "error": "text-field1-module-scss-module__RZDoKa__error",
  "errorText": "text-field1-module-scss-module__RZDoKa__errorText",
  "label": "text-field1-module-scss-module__RZDoKa__label",
  "row": "text-field1-module-scss-module__RZDoKa__row",
  "textField": "text-field1-module-scss-module__RZDoKa__textField",
});
